import { Accordion } from "react-bootstrap";
import { useState } from "react";
const ActivityComponent = ({
  fy_list,
  globalDateId,
  data,
  subheadName,
  subheadId,
  activity,
}) => {
  const [activeKeys, setActiveKeys] = useState([]);

  const toggleAccordion = (key) => {
    setActiveKeys(
      (prevKeys) =>
        prevKeys.includes(key)
          ? prevKeys.filter((k) => k !== key) // Remove key if it's already open
          : [...prevKeys, key] // Add key if it's closed
    );
  };
  return (
    <Accordion style={{ border: "0" }}>
      <Accordion.Item
        eventKey={`suubhead_activity_${subheadId}`}
        style={{ borderRadius: "0", border: "0" }}
      >
        <Accordion.Header
          onClick={() => toggleAccordion(`suubhead_activity_${subheadId}`)}
        >
          <div className="w-100 d-flex justify-content-between">
            <span>{subheadName}</span>
            <span
              className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
              style={{
                height: "13.33px",
                width: "13.33px",
              }}
            >
              {activeKeys.includes(`suubhead_activity_${subheadId}`) ? "-" : "+"}
            </span>
          </div>
        </Accordion.Header>
        <Accordion.Body>
            <div className="row">
                <div className="row pt-2 m-0">
                <div className="col-3 d-flex justify-content-between align-items-center">
                    <span className="text-black-60 fs-12px">Activity</span>
                </div>
                <div className="col-3 d-flex justify-content-between align-items-center">
                    <span className="text-black-60 fs-12px">
                    FY{" "}
                    {fy_list?.map((val, ind) => {
                        return val?.id == globalDateId && val?.year;
                    })}
                    </span>
                </div>
                <div className="col-3 d-flex justify-content-between align-items-center">
                    <span className="text-black-60 fs-12px">
                    Previous FY Balance
                    </span>
                    <i className="icon-info"></i>
                </div>
                <div className="col-3 d-flex justify-content-between align-items-center">
                    <span className="text-black-60 fs-12px">Total</span>
                </div>
                </div>
                {/* ===================================values================================= */}
                
                {data?.map((act, activityIndex) => {
                    // Find activity name
                    const activityName = activity?.find(e => Number(e.id) === Number(act.activity_id))?.activity || 'N/A';
                    
                    return (
                        <>
                        <div className="row pb-2 m-0" key={activityIndex}>
                            <div className="col-3 d-flex align-items-center">
                            {!activeKeys.includes(`activity_${act.activity_id}_${subheadId}`) ? (
                                <i
                                className="icon-keyboard_arrow_right cursor-pointer"
                                onClick={() => toggleAccordion(`activity_${act.activity_id}_${subheadId}`)}
                                ></i>
                            ) : (
                                <i
                                className="icon-keyboard_arrow_down cursor-pointer"
                                onClick={() => toggleAccordion(`activity_${act.activity_id}_${subheadId}`)}
                                ></i>
                            )}
                            <span className="fs-14px fw-500">{activityName}</span>
                            </div>
                            <div className="col-3 d-flex justify-content-between align-items-center">
                            <span className="fs-14px fw-500">{act.from_current_fy?.toLocaleString('en-IN') || '0.00'}</span>
                            </div>
                            <div className="col-3 d-flex justify-content-between align-items-center">
                            <span className="fs-14px fw-500">{act.from_prev_fy?.toLocaleString('en-IN') || '0.00'}</span>
                            </div>
                            <div className="col-3 d-flex justify-content-between align-items-center">
                            <span className="fs-14px fw-500 text-success-100">
                                {((act.from_current_fy || 0) + (act.from_prev_fy || 0))?.toLocaleString('en-IN')}
                            </span>
                            </div>
                        </div>
                        {activeKeys.includes(`activity_${act.activity_id}_${subheadId}`) && (
                            <div>
                                <div className="row pb-2 m-0">
                                <div className="col-3 d-flex align-items-center">
                                    <span className="fs-14px fw-500">&nbsp; Vendor</span>
                                </div>
                                <div className="col-3 d-flex justify-content-between align-items-center">
                                    <span className="fs-14px fw-500">
                                    {act.current_fy_detail?.vendor?.toLocaleString('en-IN') || '0.00'}
                                    </span>
                                </div>
                                <div className="col-3 d-flex justify-content-between align-items-center">
                                    <span className="fs-14px fw-500">
                                    {act.prev_fy_detail?.vendor?.toLocaleString('en-IN') || '0.00'}
                                    </span>
                                </div>
                                <div className="col-3 d-flex justify-content-between align-items-center">
                                    <span className="fs-14px fw-500 text-success-100">
                                    {(act.current_fy_detail?.vendor || 0 + act.prev_fy_detail?.vendor || 0)?.toLocaleString('en-IN')}
                                    </span>
                                </div>
                                </div>
                                <div className="row pb-2 m-0">
                                <div className="col-3 d-flex align-items-center">
                                    <span className="fs-14px fw-500">DBT/NACH</span>
                                </div>
                                <div className="col-3 d-flex justify-content-between align-items-center">
                                    <span className="fs-14px fw-500">
                                    {act.current_fy_detail?.reimbursement?.toLocaleString('en-IN') || '0.00'}
                                    </span>
                                </div>
                                <div className="col-3 d-flex justify-content-between align-items-center">
                                    <span className="fs-14px fw-500">
                                    {act.prev_fy_detail?.reimbursement?.toLocaleString('en-IN') || '0.00'}
                                    </span>
                                </div>
                                <div className="col-3 d-flex justify-content-between align-items-center">
                                    <span className="fs-14px fw-500 text-success-100">
                                    {(act.current_fy_detail?.reimbursement || 0 + act.prev_fy_detail?.reimbursement || 0)?.toLocaleString('en-IN')}
                                    </span>
                                </div>
                                </div>
                                <div className="row pb-2 m-0">
                                <div className="col-3 d-flex align-items-center">
                                    <span className="fs-14px fw-500">Salary</span>
                                </div>
                                <div className="col-3 d-flex justify-content-between align-items-center">
                                    <span className="fs-14px fw-500">
                                    {act.current_fy_detail?.salaries?.toLocaleString('en-IN') || '0.00'}
                                    </span>
                                </div>
                                <div className="col-3 d-flex justify-content-between align-items-center">
                                    <span className="fs-14px fw-500">
                                    {act.prev_fy_detail?.salaries?.toLocaleString('en-IN') || '0.00'}
                                    </span>
                                </div>
                                <div className="col-3 d-flex justify-content-between align-items-center">
                                    <span className="fs-14px fw-500 text-success-100">
                                    {(act.current_fy_detail?.salaries || 0 + act.prev_fy_detail?.salaries || 0)?.toLocaleString('en-IN')}
                                    </span>
                                </div>
                                </div>
                                <div className="row pb-2 m-0">
                                <div className="col-3 d-flex align-items-center">
                                    <span className="fs-14px fw-500">
                                    Budget Allocation
                                    </span>
                                </div>
                                <div className="col-3 d-flex justify-content-between align-items-center">
                                    <span className="fs-14px fw-500">
                                    {act.current_fy_detail?.allocation?.toLocaleString('en-IN') || '0.00'}
                                    </span>
                                </div>
                                <div className="col-3 d-flex justify-content-between align-items-center">
                                    <span className="fs-14px fw-500">
                                    {act.prev_fy_detail?.allocation?.toLocaleString('en-IN') || '0.00'}
                                    </span>
                                </div>
                                <div className="col-3 d-flex justify-content-between align-items-center">
                                    <span className="fs-14px fw-500 text-success-100">
                                    {(act.current_fy_detail?.allocation || 0 + act.prev_fy_detail?.allocation || 0)?.toLocaleString('en-IN')}
                                    </span>
                                </div>
                                </div>
                            </div>
                        )}
                        </>
                    );
                })}
                {/* ==============================sub data========================== */}
                
            </div>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};

export default ActivityComponent;
